import React, { useState } from 'react';
import { CopyToClipboard } from "react-copy-to-clipboard";
import CryptoJS from 'crypto-js';
 

function Generatehtaccessfile() {
    const [copied, setCopied] = React.useState(false);
    const [copied1, setCopied1] = React.useState(false);
    const [isChecked, setChecked] = useState(false); 
    const [isChecked1, setChecked1] = useState(false); 
    const [isChecked2, setChecked2] = useState(false); 
    const [isChecked3, setChecked3] = useState(false); 
    const [cryptopwd, setCryptopwd] = useState(''); 
    const [inputFieldsHt0, setInputFieldsHt0] =useState({
        wwwname:'',
        oldfilename:'',
        newfilename:'',
        oldfoldername:'',
        newfoldername:'',
        oldfilename1:'',
        oldfilename2:'',
        oldfilename3:'',
        cachedurationamt:'',
        proxyrevalidate: false,
        publicprivate:'',
        hotlinking_url:'',
        hotlinking_extension:'',
        hotlinking_image:'',
        htname:'',
        htfilepath:'',
        htusename:'',
        htpassword:'',
        error400:'',
        error401:'',
        error403:'',
        error404:'',
        error500:'',
        blockip:'',
        allowip:'',
        blockdots:'',
        directorypage:'',
    });
    function MyButton(props) {
        return <button {...props} />
    }
  
    const onCopy = React.useCallback(() => {
        setCopied(true);
        setTimeout(function(){
            setCopied(false);  
        },3000);
    }, []);

    const onCopy1 = React.useCallback(() => {
        setCopied1(true);
        setTimeout(function(){
            setCopied1(false);  
        },3000);
    }, []);
    
    const handleChangeCheckbox = () => { 
      setChecked(!isChecked); 
    };
    const handleChangeCheckbox1 = () => { 
      setChecked1(!isChecked1); 
    };
    const handleChangeCheckbox2 = () => { 
      setChecked2(!isChecked2); 
    };
    const handleChangeCheckbox3 = () => { 
      setChecked3(!isChecked3); 
    };  
    const handleChange = (event) => {
        let value = event.target.value;
        let name = event.target.name;
        let isChecked = event.target.checked;
        if(name==='proxy-revalidate'){
          value = isChecked;
        }
        if(name==="htpassword"){
          if(value !==''){
            console.log("value:::", value)
            const hash= CryptoJS.SHA1(value).toString();
            const htpwd = inputFieldsHt0.htusename+':'+hash;
            setCryptopwd(htpwd);
          }else{
            setCryptopwd('');
          }
        }
        if(name==='htusename'){
          const hash= CryptoJS.SHA1(inputFieldsHt0.htpassword).toString();
          const htpwd = value+':'+hash;
          setCryptopwd(htpwd);
        }
        setInputFieldsHt0((prevalue) => {
            return {
                ...prevalue,   // Spread Operator              
                [name]: value
            }
        })
    }
    
    const wwwnameData = (inputFieldsHt0.wwwname)?`
      //Rewrite to www
      Options +FollowSymLinks
      RewriteEngine on
      RewriteCond %{HTTP_HOST} ^`+inputFieldsHt0.wwwname+`[nc]
      RewriteRule ^(.*)$ `+inputFieldsHt0.wwwname+`/$1 [r=301,nc]`:'';

    const filePathData = 
            (inputFieldsHt0.oldfilename && inputFieldsHt0.newfilename)?`
      //301 Redirect Old File
      Redirect 301 `+inputFieldsHt0.oldfilename+`  `+inputFieldsHt0.newfilename+``:'';   

    const fileDirectoryData =(inputFieldsHt0.oldfoldername && inputFieldsHt0.newfoldername)?` 
    
      //301 Redirect Entire Directory
      RedirectMatch 301 `+inputFieldsHt0.oldfoldername+`(.*)  `+inputFieldsHt0.newfoldername+`/$1`:'';   

    const privatepublic =  (inputFieldsHt0.publicprivate)?inputFieldsHt0.publicprivate+",":''; 
    let totalduration = 0;
    if(inputFieldsHt0.cachedurationamt){
      let convertInInt = parseInt(inputFieldsHt0.cachedurationamt);
      if(inputFieldsHt0.cachedurationname && inputFieldsHt0.cachedurationname==='Minutes'){
        totalduration = convertInInt * 60;
      }else if(inputFieldsHt0.cachedurationname && inputFieldsHt0.cachedurationname==='Hours'){
        totalduration = convertInInt * 60*60;
      }else if(inputFieldsHt0.cachedurationname && inputFieldsHt0.cachedurationname==='Days'){
        totalduration = convertInInt * 60*60*24;
      } else if(inputFieldsHt0.cachedurationname && inputFieldsHt0.cachedurationname==='Weeks'){
        totalduration = convertInInt * 60*60*24*7;
      } else if(inputFieldsHt0.cachedurationname && inputFieldsHt0.cachedurationname==='Months'){
        totalduration = convertInInt * 60*60*24*30;
      }     
    } 
    const cssData = (inputFieldsHt0.fileextension)?`

      //Caching schema
      <FilesMatch ".(`+inputFieldsHt0.fileextension+`)$">
      Header set Cache-Control "`+privatepublic+` `+(isChecked?"proxyre-validate,":'')+` max-age=`+totalduration+`"
      </FilesMatch>`:'';     
            
    const hotlinking = (inputFieldsHt0.hotlinking_url)?
    
    `//Stop hotlinking
    RewriteCond %{HTTP_REFERER} !^$
    RewriteCond %{HTTP_REFERER} !^http://(www.)?`+inputFieldsHt0.hotlinking_url+`.*$ [NC]
    RewriteRule .(`+inputFieldsHt0.hotlinking_extension+`)$ `+inputFieldsHt0.hotlinking_image+`[R=302,L]`:'';     
    /* Htaccess file  */

    const htaccess = (inputFieldsHt0.htpassword)?`

      //Password Protect file
      <Files `+inputFieldsHt0.htname+`>
      AuthName "Prompt"
      AuthType Basic
      AuthUserFile `+inputFieldsHt0.htfilepath+`
      Require valid-user
      </Files>`:'';

    const error400 = (inputFieldsHt0.error400)?`

      //Custom 400 errors
      ErrorDocument 400 `+inputFieldsHt0.error400:'';

    const error401 = (inputFieldsHt0.error401)?`
      
      //Custom 401 errors
      ErrorDocument 401 `+inputFieldsHt0.error401:'';
      
    const error403 = (inputFieldsHt0.error403)?`

      //Custom 403 errors
      ErrorDocument 403 `+inputFieldsHt0.error403:'';

    const error404 = (inputFieldsHt0.error404)?`

      //Custom 404 errors
      ErrorDocument 404 `+inputFieldsHt0.error404:'';

    const error500 = (inputFieldsHt0.error500)?`

      //Custom 500 errors
      ErrorDocument 500 `+inputFieldsHt0.error500:'';

    const blockdots = (isChecked1)?`
    
      //Block bad bots
      RewriteEngine On 
      RewriteCond %{HTTP_USER_AGENT} ^BlackWidow [OR]
      RewriteCond %{HTTP_USER_AGENT} ^Bot\ mailto:craftbot@yahoo.com [OR]
      RewriteCond %{HTTP_USER_AGENT} ^ChinaClaw [OR]
      RewriteCond %{HTTP_USER_AGENT} ^Custo [OR]
      RewriteCond %{HTTP_USER_AGENT} ^DISCo [OR]
      RewriteCond %{HTTP_USER_AGENT} ^Download\ Demon [OR]
      RewriteCond %{HTTP_USER_AGENT} ^eCatch [OR]
      RewriteCond %{HTTP_USER_AGENT} ^EirGrabber [OR]
      RewriteCond %{HTTP_USER_AGENT} ^EmailSiphon [OR]
      RewriteCond %{HTTP_USER_AGENT} ^EmailWolf [OR]
      RewriteCond %{HTTP_USER_AGENT} ^Express\ WebPictures [OR]
      RewriteCond %{HTTP_USER_AGENT} ^ExtractorPro [OR]
      RewriteCond %{HTTP_USER_AGENT} ^EyeNetIE [OR]
      RewriteCond %{HTTP_USER_AGENT} ^FlashGet [OR]
      RewriteCond %{HTTP_USER_AGENT} ^GetRight [OR]
      RewriteCond %{HTTP_USER_AGENT} ^GetWeb! [OR]
      RewriteCond %{HTTP_USER_AGENT} ^Go!Zilla [OR]
      RewriteCond %{HTTP_USER_AGENT} ^Go-Ahead-Got-It [OR]
      RewriteCond %{HTTP_USER_AGENT} ^GrabNet [OR]
      RewriteCond %{HTTP_USER_AGENT} ^Grafula [OR]
      RewriteCond %{HTTP_USER_AGENT} ^HMView [OR]
      RewriteCond %{HTTP_USER_AGENT} HTTrack [NC,OR]
      RewriteCond %{HTTP_USER_AGENT} ^Image\ Stripper [OR]
      RewriteCond %{HTTP_USER_AGENT} ^Image\ Sucker [OR]
      RewriteCond %{HTTP_USER_AGENT} Indy\ Library [NC,OR]
      RewriteCond %{HTTP_USER_AGENT} ^InterGET [OR]
      RewriteCond %{HTTP_USER_AGENT} ^Internet\ Ninja [OR]
      RewriteCond %{HTTP_USER_AGENT} ^JetCar [OR]
      RewriteCond %{HTTP_USER_AGENT} ^JOC\ Web\ Spider [OR]
      RewriteCond %{HTTP_USER_AGENT} ^larbin [OR]
      RewriteCond %{HTTP_USER_AGENT} ^LeechFTP [OR]
      RewriteCond %{HTTP_USER_AGENT} ^Mass\ Downloader [OR]
      RewriteCond %{HTTP_USER_AGENT} ^MIDown\ tool [OR]
      RewriteCond %{HTTP_USER_AGENT} ^Mister\ PiX [OR]
      RewriteCond %{HTTP_USER_AGENT} ^Navroad [OR]
      RewriteCond %{HTTP_USER_AGENT} ^NearSite [OR]
      RewriteCond %{HTTP_USER_AGENT} ^NetAnts [OR]
      RewriteCond %{HTTP_USER_AGENT} ^NetSpider [OR]
      RewriteCond %{HTTP_USER_AGENT} ^Net\ Vampire [OR]
      RewriteCond %{HTTP_USER_AGENT} ^NetZIP [OR]
      RewriteCond %{HTTP_USER_AGENT} ^Octopus [OR]
      RewriteCond %{HTTP_USER_AGENT} ^Offline\ Explorer [OR]
      RewriteCond %{HTTP_USER_AGENT} ^Offline\ Navigator [OR]
      RewriteCond %{HTTP_USER_AGENT} ^PageGrabber [OR]
      RewriteCond %{HTTP_USER_AGENT} ^Papa\ Foto [OR]
      RewriteCond %{HTTP_USER_AGENT} ^pavuk [OR]
      RewriteCond %{HTTP_USER_AGENT} ^pcBrowser [OR]
      RewriteCond %{HTTP_USER_AGENT} ^RealDownload [OR]
      RewriteCond %{HTTP_USER_AGENT} ^ReGet [OR]
      RewriteCond %{HTTP_USER_AGENT} ^SiteSnagger [OR]
      RewriteCond %{HTTP_USER_AGENT} ^SmartDownload [OR]
      RewriteCond %{HTTP_USER_AGENT} ^SuperBot [OR]
      RewriteCond %{HTTP_USER_AGENT} ^SuperHTTP [OR]
      RewriteCond %{HTTP_USER_AGENT} ^Surfbot [OR]
      RewriteCond %{HTTP_USER_AGENT} ^tAkeOut [OR]
      RewriteCond %{HTTP_USER_AGENT} ^Teleport\ Pro [OR]
      RewriteCond %{HTTP_USER_AGENT} ^VoidEYE [OR]
      RewriteCond %{HTTP_USER_AGENT} ^Web\ Image\ Collector [OR]
      RewriteCond %{HTTP_USER_AGENT} ^Web\ Sucker [OR]
      RewriteCond %{HTTP_USER_AGENT} ^WebAuto [OR]
      RewriteCond %{HTTP_USER_AGENT} ^WebCopier [OR]
      RewriteCond %{HTTP_USER_AGENT} ^WebFetch [OR]
      RewriteCond %{HTTP_USER_AGENT} ^WebGo\ IS [OR]
      RewriteCond %{HTTP_USER_AGENT} ^WebLeacher [OR]
      RewriteCond %{HTTP_USER_AGENT} ^WebReaper [OR]
      RewriteCond %{HTTP_USER_AGENT} ^WebSauger [OR]
      RewriteCond %{HTTP_USER_AGENT} ^Website\ eXtractor [OR]
      RewriteCond %{HTTP_USER_AGENT} ^Website\ Quester [OR]
      RewriteCond %{HTTP_USER_AGENT} ^WebStripper [OR]
      RewriteCond %{HTTP_USER_AGENT} ^WebWhacker [OR]
      RewriteCond %{HTTP_USER_AGENT} ^WebZIP [OR]
      RewriteCond %{HTTP_USER_AGENT} ^Wget [OR]
      RewriteCond %{HTTP_USER_AGENT} ^Widow [OR]
      RewriteCond %{HTTP_USER_AGENT} ^WWWOFFLE [OR]
      RewriteCond %{HTTP_USER_AGENT} ^Xaldon\ WebSpider [OR]
      RewriteCond %{HTTP_USER_AGENT} ^Zeus
      RewriteRule ^.* - [F,L]`:'';  
    const directorypage = (inputFieldsHt0.directorypage)?`

      //Change default directory page
      DirectoryIndex `+inputFieldsHt0.directorypage:'';

    const prevent_viewing = (isChecked2)?`

      //Prevent viewing of .htaccess file
      <Files .htaccess>
      order allow,deny
      deny from all
      </Files>`:'';   
    const preventdirecotry = (isChecked3)?`

      //Prevent directory listings
      Options All -Indexes`:'';   

    const blockipData = (inputFieldsHt0.blockip)?`
      deny from `+ inputFieldsHt0.blockip:'';
    const allowipData = (inputFieldsHt0.blockip)?`
      allow from `+ inputFieldsHt0.blockip:'';
    const blockAllowip = (inputFieldsHt0.blockip || inputFieldsHt0.allowip)?`
      # Block users by IP
      order allow,deny  `+
      blockipData
      +` `+
      allowipData:'';        
    const EvIsMyCopy = wwwnameData
        +'  '+
        filePathData
        +'  '+
        fileDirectoryData
        +' '+
        cssData
        +' '+
        htaccess
        +' '+
        hotlinking
        +' '+
        error400
        +' '+
        error401
        +' '+
        error403
        +' '+
        error404
        +' '+
        error500
        +' '+
        blockAllowip
        +' '+
        blockdots
        +' '+
        directorypage
        +' '+
        prevent_viewing
        +' '+
        preventdirecotry; 
                                      
    return (
        <div className='row mt-5 htaccessredirect_class'>
            <div className='col-md-8 mb-5 border htaccessredirect_form'>
                <div className="row input_fields d-flex">
                    <div className="col-md-12">
                      <div className='mt-2 mb-2'><b>Rewrite to www</b> </div>
                        <div className='row mt-2 mb-2'>
                          <div className='col-3 label-cls'>
                              <label>Domain Name</label>
                          </div>
                          <div className='col-6'>
                            <div className="form-group me-2 mb-2">
                            <input type="text" onChange={(evnt) => handleChange(evnt)} value={inputFieldsHt0.wwwname} name="wwwname" className="form-control" placeholder="example.com" />
                            </div>
                          </div>
                          <div className='col-3'>

                          </div>
                        </div>
                    </div>
                    <div className="col-md-12">
                      <div className='mt-2 mb-2'><b>301 Redirect File or Directory</b> </div>
                      <div className='row mt-2 mb-2'> 
                        <div className='col-3 label-cls'>
                            <label>Old File Path</label>
                        </div>
                        <div className='col-6'>
                          <div className="form-group me-2 mb-2">
                            <input type="text" onChange={(evnt) => handleChange(evnt)} value={inputFieldsHt0.oldfilename} name="oldfilename" className="form-control" placeholder="/oldfile.html" />
                          </div>
                        </div>
                        <div className='col-3'>
                            
                        </div>
                      </div>
                      <div className='row mt-2 mb-2'> 
                        <div className='col-3 label-cls'>
                            <label>New File Path</label>
                        </div>
                        <div className='col-6'>
                          <div className="form-group me-2 mb-2">
                            <input type="text" onChange={(evnt) => handleChange(evnt)} value={inputFieldsHt0.newfilename} name="newfilename" className="form-control" placeholder="/newfile.html" />
                          </div>
                        </div>
                        <div className='col-3'>
                            
                        </div>
                      </div>
                      <div className='row mt-2 mb-2'> 
                        <div className='col-3 label-cls'>
                            <label>Old Directory Path </label>
                        </div>
                        <div className='col-6'>
                          <div className="form-group me-2 mb-2">
                            <input type="text" onChange={(evnt) => handleChange(evnt)} value={inputFieldsHt0.oldfoldername} name="oldfoldername" className="form-control" placeholder="/olddir" />
                          </div>
                        </div>
                        <div className='col-3'>
                            
                        </div>
                      </div>
                      <div className='row mt-2 mb-2'> 
                        <div className='col-3 label-cls'>
                            <label>New Directory Path</label>
                        </div>
                        <div className='col-6'>
                          <div className="form-group me-2 mb-2">
                            <input type="text" onChange={(evnt) => handleChange(evnt)} value={inputFieldsHt0.newfoldername} name="newfoldername" className="form-control" placeholder="/newdir" />
                          </div>
                        </div>
                        <div className='col-3'>
                            
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className='mt-2 mb-2'><b>Caching Javascript, CSS, and Images</b> </div>
                      <div className='row mt-2 mb-2'> 
                        <div className='col-3 label-cls'>
                            <label>File Extensions</label>
                        </div>
                        <div className='col-6'>
                          <div className="form-group me-2 mb-2">
                            <input type="text" onChange={(evnt) => handleChange(evnt)} value={inputFieldsHt0.fileextension} name="fileextension" className="form-control" placeholder="jpg,png,css,js" />
                          </div>
                        </div>
                        <div className='col-3'>
                            <span>Comma separated list. Omit leading "."</span>
                        </div>
                      </div>
                      <div className='row mt-2 mb-2'> 
                        <div className='col-3 label-cls'>
                            <label>Cache Duration</label>
                        </div>
                        <div className='col-3'>
                          <div className="form-group me-2 mb-2">
                            <input type="text" onChange={(evnt) => handleChange(evnt)} value={inputFieldsHt0.cachedurationamt} name="cachedurationamt" className="form-control" placeholder="60" />
                          </div>
                        </div>
                        <div className='col-3'>
                          <div className="form-group me-2 mb-2">
                            <select onChange={(evnt) => handleChange(evnt)} value={inputFieldsHt0.cachedurationname} name="cachedurationname" className="form-control">
                              <option value="">Please Select</option>
                              <option value="Minutes">Minutes</option>
                              <option value="Hours">Hours</option>
                              <option value="Days">Days</option>
                              <option value="Weeks">Weeks</option>
                              <option value="Months">Months</option>
                            </select>
                          </div>
                        </div>
                        <div className='col-3'>
                            
                        </div>
                      </div>
                      <div className='row mt-2 mb-2'> 
                        <div className='col-3 label-cls'> 
                        </div>
                        <div className='col-6'>
                          <div className="form-group me-2 mb-2">
                            <input className='me-1' type="radio" onChange={(evnt) => handleChange(evnt)} value="public" name="publicprivate"/>
                            <label htmlFor="huey" className='me-2'>Public</label>
                            <input className='me-1' type="radio" onChange={(evnt) => handleChange(evnt)} value="private" name="publicprivate"/>
                            <label htmlFor="huey" className='me-2'>Private</label>
                            <input className='me-1' type="checkbox" onChange={(evnt) => handleChangeCheckbox(evnt)} value="proxyre-validate" id="scales" name="proxyrevalidate" />
                            <label htmlFor="scales">Must Revalidate</label>
                          </div>
                        </div>
                        <div className='col-3'>
                            
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className='mt-2 mb-2'><b>Password protect file (requires .htpasswd file)</b> </div>
                      <div className='row mt-2 mb-2'> 
                        <div className='col-3 label-cls'>
                            <label>File Name</label>
                        </div>
                        <div className='col-6'>
                          <div className="form-group me-2 mb-2">
                            <input type="text" onChange={(evnt) => handleChange(evnt)} value={inputFieldsHt0.htname} name="htname" className="form-control" placeholder="/admin" />
                          </div>
                        </div>
                        <div className='col-3'>
                        </div>
                      </div>
                      <div className='row mt-2 mb-2'> 
                        <div className='col-3 label-cls'>
                            <label>.htpasswd File Path</label>
                        </div>
                        <div className='col-6'>
                          <div className="form-group me-2 mb-2">
                            <input type="text" onChange={(evnt) => handleChange(evnt)} value={inputFieldsHt0.htfilepath} name="htfilepath" className="form-control" placeholder='/nhome/user/.htpassword' />
                               
                          </div>
                        </div>
                        <div className='col-3'>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className='mt-2 mb-2'><b>htpasswd Generator</b> </div>
                      <div className='row mt-2 mb-2'> 
                        <div className='col-3 label-cls'>
                            <label>Username</label>
                        </div>
                        <div className='col-6'>
                          <div className="form-group me-2 mb-2">
                            <input type="text" onChange={(evnt) => handleChange(evnt)} value={inputFieldsHt0.htusename} name="htusename" className="form-control" placeholder="Username" />
                          </div>
                        </div>
                        <div className='col-3'>
                        </div>
                      </div>
                      <div className='row mt-2 mb-2'> 
                        <div className='col-3 label-cls'>
                            <label>Password</label>
                        </div>
                        <div className='col-6'>
                          <div className="form-group me-2 mb-2">
                            <input type="text" onChange={(evnt) => handleChange(evnt)} value={inputFieldsHt0.htpassword} name="htpassword" className="form-control" placeholder='Password'/>
                               
                          </div>
                        </div>
                        <div className='col-3'>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className='mt-2 mb-2'><b>Prevent Hotlinking</b> </div>
                      <div className='row mt-2 mb-2'> 
                        <div className='col-3 label-cls'>
                            <label>Referring URL</label>
                        </div>
                        <div className='col-6'>
                          <div className="form-group me-2 mb-2">
                            <input type="text" onChange={(evnt) => handleChange(evnt)} value={inputFieldsHt0.hotlinking_url} name="hotlinking_url" className="form-control" placeholder="google.com" />
                          </div>
                        </div>
                        <div className='col-3'>
                            <span>The domain that is hotlinking to you.</span>
                        </div>
                      </div>
                      <div className='row mt-2 mb-2'> 
                        <div className='col-3 label-cls'>
                            <label>File Extension</label>
                        </div>
                        <div className='col-6'>
                          <div className="form-group me-2 mb-2">
                            <input type="text" onChange={(evnt) => handleChange(evnt)} value={inputFieldsHt0.hotlinking_extension} name="hotlinking_extension" className="form-control" />
                               
                          </div>
                        </div>
                        <div className='col-3'>
                            <span>Comma separated list. Omit leading "."</span>
                        </div>
                      </div>
                      <div className='row mt-2 mb-2'> 
                        <div className='col-3 label-cls'> 
                          <label>No hotlinking Image</label>
                        </div>
                        <div className='col-6'>
                          <div className="form-group me-2 mb-2">
                            <input type="text" onChange={(evnt) => handleChange(evnt)} value={inputFieldsHt0.hotlinking_image} name="hotlinking_image" className='form-control' placeholder='http://www.example.com/hotlinker.png'/>
                          </div>
                        </div>
                        <div className='col-3'>
                              <span>Optional. What to show instead of the intended image.</span>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className='mt-2 mb-2'><b>Custom Error Pages (400, 404, 500, etc)</b> </div>
                      <div className='row mt-2 mb-2'> 
                        <div className='col-3 label-cls'>
                            <label>400 Error file path</label>
                        </div>
                        <div className='col-6'>
                          <div className="form-group me-2 mb-2">
                            <input type="text" onChange={(evnt) => handleChange(evnt)} value={inputFieldsHt0.error400} name="error400" className="form-control" placeholder="/home/www/400.html" />
                          </div>
                        </div>
                        <div className='col-3'>
                            <span>Bad Request</span>
                        </div>
                      </div>
                      <div className='row mt-2 mb-2'> 
                        <div className='col-3 label-cls'>
                            <label>401 Error file path</label>
                        </div>
                        <div className='col-6'>
                          <div className="form-group me-2 mb-2">
                            <input type="text" onChange={(evnt) => handleChange(evnt)} value={inputFieldsHt0.error401} name="error401" className="form-control" placeholder="/home/www/401.html" />
                               
                          </div>
                        </div>
                        <div className='col-3'>
                            <span>Auth Required</span>
                        </div>
                      </div>
                      <div className='row mt-2 mb-2'> 
                        <div className='col-3 label-cls'> 
                          <label>403 Error file path</label>
                        </div>
                        <div className='col-6'>
                          <div className="form-group me-2 mb-2">
                            <input type="text" onChange={(evnt) => handleChange(evnt)} value={inputFieldsHt0.error403} name="error403" className='form-control' placeholder='/home/www/403.html'/>
                          </div>
                        </div>
                        <div className='col-3'>
                              <span>Forbidden</span>
                        </div>
                      </div>
                      <div className='row mt-2 mb-2'> 
                        <div className='col-3 label-cls'> 
                          <label>404 Error file path</label>
                        </div>
                        <div className='col-6'>
                          <div className="form-group me-2 mb-2">
                            <input type="text" onChange={(evnt) => handleChange(evnt)} value={inputFieldsHt0.error404} name="error404" className='form-control' placeholder='/home/www/404.html'/>
                          </div>
                        </div>
                        <div className='col-3'>
                              <span>Not Found</span>
                        </div>
                      </div>
                      <div className='row mt-2 mb-2'> 
                        <div className='col-3 label-cls'> 
                          <label>500 Error file path</label>
                        </div>
                        <div className='col-6'>
                          <div className="form-group me-2 mb-2">
                            <input type="text" onChange={(evnt) => handleChange(evnt)} value={inputFieldsHt0.error500} name="error500" className='form-control' placeholder='/home/www/500.html'/>
                          </div>
                        </div>
                        <div className='col-3'>
                              <span>Internal Server Error</span>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className='mt-2 mb-2'><b>Block or Allow an IP</b> </div>
                      <div className='row mt-2 mb-2'> 
                        <div className='col-3 label-cls'>
                            <label>Block these IPs</label>
                        </div>
                        <div className='col-6'>
                          <div className="form-group me-2 mb-2">
                            <input type="text" onChange={(evnt) => handleChange(evnt)} value={inputFieldsHt0.blockip} name="blockip" className="form-control" placeholder="192.168.1.1,192.168.2.1" />
                          </div>
                        </div>
                        <div className='col-3'>
                            <span>Comma separated list</span>
                        </div>
                      </div>
                      <div className='row mt-2 mb-2'> 
                        <div className='col-3 label-cls'>
                            <label>Allow these IPs</label>
                        </div>
                        <div className='col-6'>
                          <div className="form-group me-2 mb-2">
                            <input type="text" onChange={(evnt) => handleChange(evnt)} value={inputFieldsHt0.allowip} name="allowip" className="form-control" placeholder="192.168.1.1,192.168.2.1" />
                               
                          </div>
                        </div>
                        <div className='col-3'>
                            <span>Comma separated list</span>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className='mt-2 mb-2'><b>Block bots</b> </div>
                      <div className='row mt-2 mb-2'> 
                        <div className='col-3 label-cls'>
                            <label htmlFor="blockDots">Enable</label>
                        </div>
                        <div className='col-6'>
                          <div className="form-group me-2 mb-2">
                            <input type="checkbox" onChange={(evnt) => handleChangeCheckbox1(evnt)} value="blockdots" name="blockdots" id="blockDots" className="form" />
                          </div>
                        </div>
                        <div className='col-3'>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className='mt-2 mb-2'><b>Change default directory page</b> </div>
                      <div className='row mt-2 mb-2'> 
                        <div className='col-3 label-cls'>
                            <label htmlFor="directorypage">Directory Page</label>
                        </div>
                        <div className='col-6'>
                          <div className="form-group me-2 mb-2">
                            <input type="text" onChange={(evnt) => handleChange(evnt)} value={inputFieldsHt0.directorypage} name="directorypage" className="form-control" />
                          </div>
                        </div>
                        <div className='col-3'>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className='mt-2 mb-2'><b>Prevent viewing of .htaccess file</b> </div>
                      <div className='row mt-2 mb-2'> 
                        <div className='col-3 label-cls'>
                            <label htmlFor="prevent_viewing">Enable</label>
                        </div>
                        <div className='col-6'>
                          <div className="form-group me-2 mb-2">
                            <input type="checkbox" onChange={(evnt) => handleChangeCheckbox2(evnt)} value="prevent_viewing" name="prevent_viewing" id="prevent_viewing" className="form" />
                          </div>
                        </div>
                        <div className='col-3'>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className='mt-2 mb-2'><b>Prevent Directory Listing</b> </div>
                      <div className='row mt-2 mb-2'> 
                        <div className='col-3 label-cls'>
                            <label htmlFor="prevent_directory">Enable</label>
                        </div>
                        <div className='col-6'>
                          <div className="form-group me-2 mb-2">
                            <input type="checkbox" onChange={(evnt) => handleChangeCheckbox3(evnt)} value="prevent_directory" name="prevent_directory" id="prevent_directory" className="form" />
                          </div>
                        </div>
                        <div className='col-3'>
                        </div>
                      </div>
                    </div> 
                </div>
            </div>
          <div className='col-md-4 right_sidebar'>
           <div className="card">
             <div className="card-header">
               <CopyToClipboard onCopy={onCopy} text={EvIsMyCopy} >
                 <MyButton className="btn btn-success">Copy to Htaccess file</MyButton>
               </CopyToClipboard>
             </div>
             <div className="card-body">
                <pre>{EvIsMyCopy}</pre>
              </div>
             {copied && 
               <div className="card-footer text-muted">
                 <div className="p-2 btn-success rounded">✅ copied successfully</div>
               </div>
             }
           </div>
            {cryptopwd && 
              <div className="card">
              <div className="card-header">
                <CopyToClipboard onCopy={onCopy1} text={cryptopwd} >
                  <MyButton className="btn btn-success">Copy to your Your .htpasswd File</MyButton>
                </CopyToClipboard>
              </div>
              <div className="card-body">
                {cryptopwd}
                </div>
              {copied1 && 
                <div className="card-footer text-muted">
                  <div className="p-2 btn-success rounded">✅ copied successfully</div>
                </div>
              }
              </div>
            }
          </div>
        </div>
  );
}

export default Generatehtaccessfile